import React, { useState, useMemo } from 'react';
import { Alert, Typography, Link } from '@one-thd/sui-atomic-components';
import { routeBuilder } from '../../../utils/general';
import { isBopisOutOfStockRecoverable } from '../../order-details/util/FulfillmentStatus';
export var BopisOutOfStockRecoveryAlert = function (_a) {
    var allOrderDetails = _a.allOrderDetails;
    var _b = useState(true), showAlert = _b[0], setShowAlert = _b[1];
    /* This function filters unique BOPIS orders where at least one fulfillmentGroup has a cancellationStatus of 'OUT_OF_STOCK',
    isOosRecoveryEnabled set to true in actions, and a non-empty oosRecoveryOptions array. */
    var bopisOutOfStockRecoverableOrders = useMemo(function () {
        var uniqueOrderNumbers = new Set();
        return allOrderDetails === null || allOrderDetails === void 0 ? void 0 : allOrderDetails.filter(function (order) {
            var _a, _b;
            var orderNumber = (order === null || order === void 0 ? void 0 : order.orderNumber) || ((_a = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]);
            if (!orderNumber || uniqueOrderNumbers.has(orderNumber)) {
                return false;
            }
            var hasBopisRecoverable = (_b = order === null || order === void 0 ? void 0 : order.fulfillmentGroups) === null || _b === void 0 ? void 0 : _b.some(function (fulfillmentGroup) {
                return (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) === 'BuyOnlinePickupInStore' &&
                    isBopisOutOfStockRecoverable(fulfillmentGroup);
            });
            if (hasBopisRecoverable) {
                uniqueOrderNumbers.add(orderNumber);
                return true;
            }
            return false;
        });
    }, [allOrderDetails]);
    var renderOrderLinks = function (outOfStockRecoverableOrders) {
        return outOfStockRecoverableOrders.map(function (orderDetailsData, index) {
            var _a;
            var orderNumber = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) || ((_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]);
            var orderDetailsUrl = "/myaccount/order-details".concat(routeBuilder({
                orderNumber: orderNumber,
                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                orderOrigin: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin,
                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                nickName: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.nickName,
            }));
            return (React.createElement("span", { key: "out-of-stock-recoverable-order-".concat(index) },
                React.createElement(Link, { href: orderDetailsUrl, variant: "body-sm" }, "Order # ".concat(orderNumber)),
                index < outOfStockRecoverableOrders.length - 1 && ', '));
        });
    };
    if (!(bopisOutOfStockRecoverableOrders === null || bopisOutOfStockRecoverableOrders === void 0 ? void 0 : bopisOutOfStockRecoverableOrders.length) || !showAlert)
        return null;
    return (React.createElement(Alert, { status: "warning", size: "large", headline: "Some of your items are out of stock.", onClose: function () {
            setShowAlert(false);
        } },
        React.createElement(Typography, { variant: "body-sm" },
            "Review your options for",
            ' ',
            renderOrderLinks(bopisOutOfStockRecoverableOrders))));
};
